import { render } from "./InternalTransferInitiated.vue?vue&type=template&id=998886c8&scoped=true"
import script from "./InternalTransferInitiated.vue?vue&type=script&lang=js"
export * from "./InternalTransferInitiated.vue?vue&type=script&lang=js"

import "./InternalTransferInitiated.vue?vue&type=style&index=0&id=998886c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998886c8"]])

export default __exports__